const SITE_TITLE = "Blueshell Esports - Student esports association"

/** What the browser tab says for a page of this name, or for the site as a whole. */
export const tabTitle = (page?: string): string => page ? `${page} — Blueshell Esports` : SITE_TITLE
